var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"justify-center",attrs:{"dark":""}},[_vm._v(" Serviteca © 2022 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }